import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import { authSelector } from "../../feature/auth/authSelector";

import Layout from "./../Layout";

const AuthWrapper = ({ children, isPartner }) => {
  const { userState, partnerIsWaiting, partnerIsRejected } = useSelector(
    ({ authState }) => authSelector(authState)
  );
  const nativate = useNavigate();

  useEffect(() => {
    if (!userState.accessToken && !partnerIsWaiting && !partnerIsRejected) {
      nativate("/sign-in");
    }
  }, [userState, nativate, partnerIsWaiting, partnerIsRejected]);

  if (
    (userState.role !== "admin" || partnerIsWaiting || partnerIsRejected) &&
    isPartner
  ) {
    return <Layout isPartner>{children}</Layout>;
  }
  if (userState.role !== "admin" && !isPartner) {
    return <Navigate to="/partner/dashboard" />;
  }
  if (userState.role === "admin" && !isPartner) {
    return <Layout>{children}</Layout>;
  }
  return <Navigate to="/admin/dashboard" />;
};

export default AuthWrapper;
